import { ApiEventSetting } from '@api/model/api-event-setting';

/**
 * Checks if a boolean event setting is set to 'true'.
 *
 * @param settings - Array of event settings to search
 * @param name - The setting name to look for
 * @returns True if the setting exists and its value is 'true', false otherwise
 */
export const isEventSettingTrue = (
  settings: ApiEventSetting[],
  name:
    | 'isEventLive'
    | 'isShowCountdown'
    | 'isParticipantDataAvailable'
): boolean => settings.find(setting => setting.name === name)?.value === 'true';

/**
 * Retrieves the string value of an event setting.
 *
 * @param settings - Array of event settings to search
 * @param name - The setting name to look for
 * @returns The setting value if found, undefined otherwise
 */
export const getEventSettingValue = (
  settings: ApiEventSetting[],
  name: 'appNotes' | 'startTime' | 'actions',
): string | undefined =>
  settings.find(setting => setting.name === name)?.value ?? undefined;
